import React ,{useEffect}from "react";
import NavbarHeader from "../pages/Navbar";
import FooterBfsg from "../pages/FooterBfsg";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import SkinCare2 from "../Image/Candle/diptque.png";
import SkinCare3 from "../Image/Candle/margila.png";
import SkinCare4 from "../Image/Candle/NestNY-Candel.png";
import HeroBannerCandle from "../Image/HomeDecor/HomeDecorBanner.png";

function Candle() {
  useEffect(() => {
    document.title = 'Home Decor by Diptyque, Maison Margiela | Beauty Fashion Sales Group ';
  }, []); 
  return (
    <div>
      <NavbarHeader />

      <section className="B3bPageTop Candle">
        <div className="container">
          <div className="HeroBanner">
            <img src={HeroBannerCandle} alt="home FRAGRANCE" />
            <h3>home FRAGRANCE</h3>
          </div>

          <div>
            <div className="row g-0">
              <div className="col-lg-3 col-md-3 col-sm-6">
                <Link to="/brands/Diptyque">
                  <div className="BrandProduct BR  ">
                    <div>
                      <img src={SkinCare2} alt="" />
                    </div>

                    <h2>Diptyque</h2>
                  </div>
                </Link>
              </div>

              <div className="col-lg-3 col-md-3 col-sm-6">
                <Link to="/brands/MaisonMargiela">
                  <div className="BrandProduct BR">
                    <div>
                      <img src={SkinCare3} alt="" />
                    </div>

                    <h2>Maison Margiela</h2>
                  </div>
                </Link>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-6">
                <Link to="/brands/Nest-NY">
                  <div className="BrandProduct ">
                    <div>
                      <img src={SkinCare4} alt="Nest New York" />
                    </div>

                    <h2>Nest New York</h2>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterBfsg />
    </div>
  );
}

export default Candle;
